// Função utilitária para buscar produtos por tipo
const findProductByType = (items, matcher) => {
  return items.find(item => matcher(item.contele_product_id)) || {};
};

export function mountCreateContractPayload({ billing_preview, contele_customer, contele_subscription }) {

  const billing_due_day_of_month = contele_subscription.billing_due_day_of_month;
  //company legal representative 
  const company_legal_representative = contele_customer.people.find(people => people.role === 'company_legal_representative') || {}

  const company_legal_representative_document_number = company_legal_representative.document_number;
  const company_legal_representative_name = company_legal_representative.name;
  //contract data
  const contract_sign_date = new Date().toISOString();
  const contract_version = 'v1';
  //customer billing address
  const customer_billing_address = contele_customer.addresses.find(address => address.type === 'billing') || {};
  const customer_billing_address_additional_details = customer_billing_address.additional_details || '';
  const customer_billing_address_city = customer_billing_address.city;
  const customer_billing_address_neighborhood = customer_billing_address.neighborhood;
  const customer_billing_address_phone_number = customer_billing_address.phone_number || '';
  const customer_billing_address_state = customer_billing_address.state;
  const customer_billing_address_street = customer_billing_address.street;
  const customer_billing_address_number = customer_billing_address.number;
  const customer_billing_address_zipcode = customer_billing_address.zipcode;


  //customer financial
  const company_financial = contele_customer.people.find(people => people.role === 'company_financial') || {};
  const customer_company_financial_email = company_financial.email || '';
  const customer_company_financial_name = company_financial.name || '';
  const customer_company_financial_phone_number = company_financial.phone_number || '';

  //customer delivery 
  const customer_delivery_address = contele_customer.addresses.find(address => address.type === 'other') || {};
  const customer_delivery_address_additional_details = customer_delivery_address.additional_details || "";
  const customer_delivery_address_city = customer_delivery_address.city;
  const customer_delivery_address_neighborhood = customer_delivery_address.neighborhood;
  const customer_delivery_address_phone_number = customer_delivery_address.phone_number || '';
  const customer_delivery_address_state = customer_delivery_address.state;
  const customer_delivery_address_street = customer_delivery_address.street;
  const customer_delivery_address_number = customer_delivery_address.number;
  const customer_delivery_address_zipcode = customer_delivery_address.zipcode;

  const customer_document_number = contele_customer.document_number;
  const customer_name = contele_customer.name;

  const customer_system_admin = contele_customer.people.find(people => people.role === 'system_admin') || {}
  const customer_system_admin_email = customer_system_admin.email || '';
  const customer_system_admin_name = customer_system_admin.name || '';
  const customer_system_admin_phone_number = customer_system_admin.phone_number || '';

  const subscription_items = billing_preview.subscription_items || contele_subscription.items;

  const cgv_tracker_device_plug_and_play = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_device_plug_and_play_unit')
  );
  const tracker_2g = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_device_2G_unit')
  );
  const tracker_4g = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_device_4G_unit')
  );
  const tracker_feature_fuel_lock_12v = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_feature_fuel_lock_12_unit')
  );
  const tracker_feature_fuel_lock_24v = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_feature_fuel_lock_24_unit')
  );
  const contele_system = findProductByType(subscription_items,
    id => id.includes('cgv_contele_system_unit')
  );
  const tracker_camera = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_camera_unit') && !id.includes('_ia_')
  );
  const tracker_camera_ia = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_camera_ia_unit')
  );
  const fine_manager = findProductByType(subscription_items,
    id => id.includes('cgv_tracker_fine_manager_unit')
  );
  const camera_setup = findProductByType(subscription_items,
    id => id.includes('cgv_cam_initial_setup_unit')
  );

  const subscription_item_cgv_tracker_device_plug_and_play_quantity = cgv_tracker_device_plug_and_play.quantity || 0;
  const subscription_item_cgv_tracker_device_plug_and_play_unit_absolute_value = cgv_tracker_device_plug_and_play.unit_price_per_cycle || 0;
  const subscription_item_cgv_tracker_device_plug_and_play_total_absolute_value = cgv_tracker_device_plug_and_play.total_price_without_discount_per_cycle || 0;

  const subscription_total_price_without_discount_per_cycle = billing_preview.total_price_without_discount_per_cycle ||
    subscription_items.reduce((acc, item) => acc + (item.total_price_without_discount_per_cycle || 0), 0);

  const subscription_total_price_with_discount_per_cycle = billing_preview.total_price_with_discount_per_cycle ||
    subscription_items.reduce((acc, item) => acc + (item.total_price_with_discount_per_cycle || 0), 0);

  const subscription_discount_absolute_value_per_cycle = billing_preview.total_discount_absolute_value_per_cycle ||
    (subscription_total_price_without_discount_per_cycle - subscription_total_price_with_discount_per_cycle);

  const subscription_item_cgv_tracker_device_quantity = (tracker_2g.quantity || 0) + (tracker_4g.quantity || 0);
  const subscription_item_cgv_tracker_device_unit_absolute_value = (tracker_2g.unit_price_per_cycle || 0) + (tracker_4g.unit_price_per_cycle || 0);
  const subscription_item_cgv_tracker_device_total_absolute_value = (tracker_2g.total_price_without_discount_per_cycle || 0) + (tracker_4g.total_price_without_discount_per_cycle || 0);

  const subscription_item_cgv_tracker_feature_fuel_lock_quantity = (tracker_feature_fuel_lock_12v.quantity || 0) + (tracker_feature_fuel_lock_24v.quantity || 0);
  const subscription_item_cgv_tracker_feature_fuel_lock_unit_absolute_value = (tracker_feature_fuel_lock_12v.unit_price_per_cycle || 0) + (tracker_feature_fuel_lock_24v.unit_price_per_cycle || 0);
  const subscription_item_cgv_tracker_feature_fuel_lock_total_absolute_value = (tracker_feature_fuel_lock_12v.total_price_without_discount_per_cycle || 0) + (tracker_feature_fuel_lock_24v.total_price_without_discount_per_cycle || 0);

  return {
    billing_due_day_of_month,
    company_legal_representative_document_number,
    company_legal_representative_name,
    contract_sign_date,
    contract_version,
    customer_billing_address_additional_details,
    customer_billing_address_city,
    customer_billing_address_neighborhood,
    customer_billing_address_phone_number,
    customer_billing_address_state,
    customer_billing_address_street,
    customer_billing_address_number,
    customer_billing_address_zipcode,
    customer_company_financial_email,
    customer_company_financial_name,
    customer_company_financial_phone_number,
    customer_delivery_address_additional_details,
    customer_delivery_address_city,
    customer_delivery_address_neighborhood,
    customer_delivery_address_phone_number,
    customer_delivery_address_state,
    customer_delivery_address_street,
    customer_delivery_address_number,
    customer_delivery_address_zipcode,
    customer_document_number,
    customer_name,
    customer_system_admin_email,
    customer_system_admin_name,
    customer_system_admin_phone_number,

    // Produtos principais (obrigatórios para compatibilidade)
    subscription_item_cgv_tracker_device_plug_and_play_quantity,
    subscription_item_cgv_tracker_device_plug_and_play_total_absolute_value: Number(subscription_item_cgv_tracker_device_plug_and_play_total_absolute_value),
    subscription_item_cgv_tracker_device_plug_and_play_unit_absolute_value: Number(subscription_item_cgv_tracker_device_plug_and_play_unit_absolute_value),

    subscription_item_cgv_tracker_device_quantity,
    subscription_item_cgv_tracker_device_total_absolute_value: Number(subscription_item_cgv_tracker_device_total_absolute_value),
    subscription_item_cgv_tracker_device_unit_absolute_value: Number(subscription_item_cgv_tracker_device_unit_absolute_value),

    subscription_item_cgv_tracker_feature_fuel_lock_quantity,
    subscription_item_cgv_tracker_feature_fuel_lock_total_absolute_value: Number(subscription_item_cgv_tracker_feature_fuel_lock_total_absolute_value),
    subscription_item_cgv_tracker_feature_fuel_lock_unit_absolute_value: Number(subscription_item_cgv_tracker_feature_fuel_lock_unit_absolute_value),

    // Novos produtos específicos
    subscription_item_cgv_contele_system_quantity: contele_system.quantity || 0,
    subscription_item_cgv_contele_system_unit_absolute_value: Number(contele_system.unit_price_per_cycle || 0),
    subscription_item_cgv_contele_system_total_absolute_value: Number(contele_system.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_tracker_camera_quantity: tracker_camera.quantity || 0,
    subscription_item_cgv_tracker_camera_unit_absolute_value: Number(tracker_camera.unit_price_per_cycle || 0),
    subscription_item_cgv_tracker_camera_total_absolute_value: Number(tracker_camera.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_tracker_camera_ia_quantity: tracker_camera_ia.quantity || 0,
    subscription_item_cgv_tracker_camera_ia_unit_absolute_value: Number(tracker_camera_ia.unit_price_per_cycle || 0),
    subscription_item_cgv_tracker_camera_ia_total_absolute_value: Number(tracker_camera_ia.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_tracker_fine_manager_quantity: fine_manager.quantity || 0,
    subscription_item_cgv_tracker_fine_manager_unit_absolute_value: Number(fine_manager.unit_price_per_cycle || 0),
    subscription_item_cgv_tracker_fine_manager_total_absolute_value: Number(fine_manager.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_tracker_device_2g_quantity: tracker_2g.quantity || 0,
    subscription_item_cgv_tracker_device_2g_unit_absolute_value: Number(tracker_2g.unit_price_per_cycle || 0),
    subscription_item_cgv_tracker_device_2g_total_absolute_value: Number(tracker_2g.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_tracker_device_4g_quantity: tracker_4g.quantity || 0,
    subscription_item_cgv_tracker_device_4g_unit_absolute_value: Number(tracker_4g.unit_price_per_cycle || 0),
    subscription_item_cgv_tracker_device_4g_total_absolute_value: Number(tracker_4g.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_tracker_feature_fuel_lock_12_quantity: tracker_feature_fuel_lock_12v.quantity || 0,
    subscription_item_cgv_tracker_feature_fuel_lock_12_unit_absolute_value: Number(tracker_feature_fuel_lock_12v.unit_price_per_cycle || 0),
    subscription_item_cgv_tracker_feature_fuel_lock_12_total_absolute_value: Number(tracker_feature_fuel_lock_12v.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_tracker_feature_fuel_lock_24_quantity: tracker_feature_fuel_lock_24v.quantity || 0,
    subscription_item_cgv_tracker_feature_fuel_lock_24_unit_absolute_value: Number(tracker_feature_fuel_lock_24v.unit_price_per_cycle || 0),
    subscription_item_cgv_tracker_feature_fuel_lock_24_total_absolute_value: Number(tracker_feature_fuel_lock_24v.total_price_without_discount_per_cycle || 0),

    subscription_item_cgv_cam_initial_setup_quantity: camera_setup.quantity || 0,
    subscription_item_cgv_cam_initial_setup_unit_absolute_value: Number(camera_setup.unit_price_per_cycle || 0),
    subscription_item_cgv_cam_initial_setup_total_absolute_value: Number(camera_setup.total_price_without_discount_per_cycle || 0),

    subscription_discount_absolute_value_per_cycle: Number(subscription_discount_absolute_value_per_cycle),
    subscription_total_price_with_discount_per_cycle: Number(subscription_total_price_with_discount_per_cycle),
    subscription_total_price_without_discount_per_cycle: Number(subscription_total_price_without_discount_per_cycle)
  }

};